import styled from "styled-components";

const AddWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 70vh;

  & .content{
    flex: 1;
  }
`;

export default AddWrap;